export const Difficulty = Object.freeze({
  hard: 'hard',
  normal: 'normal',
  easy: 'easy',
});

export const Priority = Object.freeze({
  high: 'high',
  medium: 'medium',
  low: 'low',
});
